import { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FetchData, { CreateEntry, GetList, UpdateEntry, GetOne } from "../../providers/dataProvider";
import { CheckNull, convertLocalToUTCDate } from "../../utils/Validate";
import validation from "./validation";
import { SuccessMessages, ErrorMessages } from "../../constants/MessageConstants";
import { ValidateMessages } from '../../constants/ValidateConstants';
import urls from "../../constants";

const useForm = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    distributorCode: "",
    distributorName: "",
    address: "",
    phone: "",
    fax: "",
    email: "",
    website: "",
    countryId: 0,
    logoUrl: "",
    headerUrl: "",
    footerUrl: "",
    isActive: true,
    assignedEngineerId: "",
    designationId: 0,
    type: "",
    companyId: "",
    additionalInfo: "",
    currencyId: 0,
    conversionRate: '',
    createdBy: localStorage.getItem("authidentity"),
    distributorContacts: [],
    distributorDocument: [],
    logo: { fileUpload: "" },
    header: { fileUpload: "" },
    footer: { fileUpload: "" },
    docs: [],
  });

  const [country, setCountry] = useState("");
  const [currency, setCurrency] = useState("");
  const [type, setType] = useState("");
  const [company, setCompany] = useState("");
  const [designation, setDesignation] = useState("");
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [createMsg, setCreateMsg] = useState(null);
  const [show, setShow] = useState(false);
  const [editDist, setEditDist] = useState({ row: null, id: null });
  const [errorShow, setErrorShow] = useState({ show: false, errorMessage: "" });
  const [docError, setDocError] = useState([]);
  const [distributorData, setDistributorData] = useState(null);
  const [authPerson, setAuthPerson] = useState(null);
  const [assignedEngineer, setAssignedEngineer] = useState("");
  const navigate = useNavigate();

  const clearError = (fieldName) => {
    setErrors((prev) => {
      if (!prev?.[fieldName]) return prev;
      const next = { ...prev };
      delete next[fieldName];
      return next;
    });
  };

  useEffect(() => {
    if (location?.state) {
      const item = location?.state;
      if (item?.id) {
        if (item?.canEdit !== true) navigate("/dashboard")
        GetOne("distributor", { id: item?.id }, setDistributorData)
      }
      else { if (item?.canAdd !== true) navigate("/dashboard") }
    }
    else { navigate("/dashboard") }
  }, [])

  useEffect(() => {
    if (distributorData?.message === "success") {
      setEditDist({ id: distributorData?.data?.id, row: distributorData?.data })
    }
  }, [distributorData])

  useEffect(() => {
    const getEditDistributorData = () => {
      if (editDist?.id) {
        setValues({
          id: editDist?.id,
          distributorCode: editDist?.row?.distributorCode,
          distributorName: editDist?.row?.distributorName,
          address: editDist?.row?.address,
          phone: editDist?.row?.phone,
          fax: editDist?.row?.fax,
          email: editDist?.row?.email,
          website: editDist?.row?.website,
          countryId: editDist?.row?.countryId,
          logoUrl: editDist?.row?.logoUrl,
          headerUrl: editDist?.row?.headerUrl,
          footerUrl: editDist?.row?.footerUrl,
          isActive: editDist?.row?.isActive,
          designationId: editDist?.row?.designationId,
          type: editDist?.row?.type,
          companyId: editDist?.row?.companyId,
          additionalInfo: editDist?.row?.additionalInfo,
          currencyId: editDist?.row?.currencyId,
          conversionRate: editDist?.row?.conversionRate,
          createdBy: editDist?.row?.createdBy,
          createdAt: editDist?.row?.createdAt,
          modifiedBy: editDist?.row?.modifiedBy,
          modifiedAt: editDist?.row?.modifiedAt,
          logo: { url: editDist?.row?.logoUrl ? editDist?.row?.logoUrl : '' },
          header: { url: editDist?.row?.headerUrl ? editDist?.row?.headerUrl : "" },
          footer: { url: editDist?.row?.footerUrl ? editDist?.row?.footerUrl : '' },
          distributorContacts: editDist?.row?.distributorContacts,
          distributorDocument: editDist?.row?.distributorDocument,
          assignedEngineerId: editDist?.row?.assignedEngineerId,
          authorizedPerson: editDist?.row?.authorizedPerson,
          additionalInfo: editDist?.row?.additionalInfo,
          editpaymentTerms: editDist?.row?.distributorPaymentTerms,
          editDeliveryTerms: editDist?.row?.distributorDeliveryTerms,
        });
      }
    }; getEditDistributorData();
  }, [editDist?.id]);

  const HandleFormChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
    clearError(name);
  };

  const HandleDragOver = (e) => { e.preventDefault() };

  const HandleDrop = (e, name) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) { HandleFileChange({ target: { files: [file] } }, name) }
  };

  const HandleFileChange = (e) => {
    if (e.target.name == "logoUrl") {
      const file = e.target.files[0];
      const url = URL.createObjectURL(file);
      setValues({
        ...values, [e.target.name]: e.target.files[0].name,
        logo: { fileUpload: e.target.files[0], url: url },
      });
    } else if (e.target.name == "headerUrl") {
      const file = e.target.files[0];
      const url = URL.createObjectURL(file);
      setValues({
        ...values, [e.target.name]: e.target.files[0].name,
        header: { fileUpload: e.target.files[0], url: url },
      });
    }
    if (e.target.name == "footerUrl") {
      const file = e.target.files[0];
      const url = URL.createObjectURL(file);
      setValues({
        ...values, [e.target.name]: e.target.files[0].name,
        footer: { fileUpload: e.target.files[0], url: url },
      });
    }
  };

  const handleDocumentChange = (e, docId) => {
    const dd = values?.docs?.map((obj, ind) => {
      if (obj?.id == docId) {
        return {
          ...obj,
          fileObj: e.target.files[0],
          fileName: e.target.files[0].name,
          file: {
            ...obj?.file,
            attachmentId: docId,
            docuUrl: e.target.files[0].name,
            expDate: null,
          },
        };
      }
      return obj;
    });
    var results = dd?.filter((item) => item?.fileName != "");
    var re = results?.map((it) => { return it?.file });
    setValues({ ...values, docs: dd, distributorDocument: re });
  };

  const handleCountryChange = (selectedOption) => {
    setCountry(selectedOption);
    setValues({ ...values, countryId: selectedOption.value,phone:""});
    clearError("country");
    clearError("phone");
  };

  const handleCurrencyChange = (selectedOption) => {
    setCurrency(selectedOption);
    setValues({ ...values, currencyId: selectedOption?.value });
    clearError("currency");
  };

  const handleTypeChange = (selectedOption) => {
    setType(selectedOption);
    setValues({ ...values, type: selectedOption?.label });
    clearError("type");
  };

  const handleDesignationChange = (selectedOption) => {
    setDesignation(selectedOption);
    setValues({ ...values, designationId: selectedOption.value });
    clearError("designation");
  };

  const handleCompanyChange = (selectedOption) => {
    setCompany(selectedOption);
    setValues({ ...values, companyId: selectedOption?.value, assignedEngineerId: "" });
    clearError("companyName");
    clearError("assignedEngineer");
  };

  const removeAttachedFile = (docId, index) => {
    const dd = values?.docs?.map((obj, ind) => {
      if (obj?.id == docId) {
        return {
          ...obj,
          fileObj: "",
          fileName: "",
          file: {
            ...obj?.file,
            attachmentId: "",
            docuUrl: "",
            expDate: null,
          },
        };
      }
      return obj;
    });
    const newValues = values?.distributorDocument.filter(
      (obj) => obj?.attachmentId != docId
    );
    setValues({ ...values, docs: dd, distributorDocument: newValues });
  };

  const handleAttachmentDate = (date, docId) => {
    const dd = values?.docs?.map((obj, ind) => {
      if (obj?.id == docId) {
        return {
          ...obj,
          file: { ...obj?.file, expDate: date },
        };
      }
      return obj;
    });

    const distDocs = values?.distributorDocument?.map((obj, ind) => {
      if (obj?.attachmentId == docId) {
        return { ...obj, expDate: date };
      }
      return obj;
    });
    setValues({ ...values, docs: dd, distributorDocument: distDocs });
  };

  const handleDeleteFile = (e, targetName) => {
    const valuesCopy = { ...values };
    if (targetName == "footer") {
      valuesCopy["footerUrl"] = "";
      valuesCopy["footer"]["url"] = ""
    }
    if (targetName == "logo") {
      valuesCopy["logoUrl"] = "";
      valuesCopy["logo"]["url"] = ""
    }
    if (targetName == "header") {
      valuesCopy["headerUrl"] = "";
      valuesCopy["header"]["url"] = ""
    }
    setValues(valuesCopy)
    clearError(`${targetName}Url`);
  };

  const isValidFileUploaded = (file) => {
    const validExtensions = ["png", "jpg"];
    const fileExtension = file?.type.split("/")[1];
    return validExtensions.includes(fileExtension);
  };

  const isValidFileSize = (file) => {
    const MAX_FILE_SIZE = 500000;
    if (file.size > MAX_FILE_SIZE) { return false } else { return true }
  };

  useEffect(() => {
    if (Object.keys(values).length != 0) {
      const derr = [...docError]
      if (values?.docs) {
        values?.docs?.map((obj, index) => {
          if (obj?.fileName != '') {
            if (obj?.dateValidation) {
              if (obj?.file?.expDate == null) {
                derr[index] = ValidateMessages?.SELECTED("Expired Date")
              } else derr[index] = false
            }
          }
          else if (obj?.fileName == '') derr[index] = false
        })
      }
      setDocError(derr)
    }
  }, [values]);

  const HandleSubmit = (e) => {
    e.preventDefault();
    setErrors(validation(values,assignedEngineer,authPerson));
    setIsSubmitting(true);
  };

  useEffect(() => {
    const errorCount = Object.values(errors).filter(Boolean).length;
    if (errorCount === 0 && !docError.includes(ValidateMessages?.SELECTED("Expired Date")) && isSubmitting) {
      setLoading(true);
      let formData = { ...values };
      delete formData["editDeliveryTerms"];
      delete formData["editpaymentTerms"];
      delete formData["logo"];
      delete formData["header"];
      delete formData["footer"];
      const dd = formData["docs"]?.filter((obj) => obj?.fileName != "");
      const format = dd?.map((obj) => {
        if (obj?.file?.expDate != null) {
          const dt = convertLocalToUTCDate(obj?.file?.expDate)
          return {
            ...obj,
            file: {
              ...obj?.file,
              expDate: dt
            }
          }
        }
        return obj
      });
      formData["distributorDocument"] = format?.map((ob) => ob?.file);
      delete formData["docs"];
      const dc = formData["distributorContacts"]?.map((contact) => {
        if (contact?.designation) {
          delete contact["designation"];
          delete contact["department"];
          delete contact["id"];
          return contact;
        } else return contact;
      });
      formData["distributorContacts"] = dc;
      if (values?.id) {
        UpdateEntry("distributor", formData, setCreateMsg, SuccessMessages?.UPDATED("Distributor"), ErrorMessages?.UPDATE_ERROR("Distributor"));
      } else {
        CreateEntry("distributor", formData, setCreateMsg, SuccessMessages?.CREATED("Distributor"), ErrorMessages?.CREATE_ERROR("Distributor"));
      }
    }
    setIsSubmitting(false)
  }, [errors]);

  useEffect(() => {
    if (createMsg?.status == urls?.SUCCESS_STATUS || createMsg?.status == urls?.SUCCESS_STATUS_OPTION) {
      setShow(true);
      setValues({});
      setLoading(false)
    } else if (createMsg?.status == urls?.FAILURE_STATUS || createMsg?.status == urls?.ERROR_STATUS) {
      let errorsmsg = createMsg.successData;
      setErrorShow({
        show: true,
        errorMessage: errorsmsg,
      });
      setLoading(false)
    }
  }, [createMsg]);

  const ErrorDoneClick = () => {
    setErrorShow({ show: false, errorMessage: "" }); setCreateMsg(null)
  };

  const SuccessDoneClick = () => {
    setShow(false); setLoading(false);
    navigate("/distributor-master");
  };

  const handleStatusChange = (e) => {
    setValues({ ...values, isActive: e.target.checked });
  };

  const handleAuthPersonChange = (selectedOption) => {
    setAuthPerson(selectedOption);
    clearError("authorizedPerson");
  };

  const handleAssignedEngineerChange = (selectedOption) => {
    setAssignedEngineer(selectedOption);
    clearError("assignedEngineer");
  };

  return {
    HandleFormChange,
    HandleSubmit,
    HandleFileChange,
    handleDocumentChange,
    handleDesignationChange,
    handleTypeChange,
    handleCurrencyChange,
    handleCountryChange,
    removeAttachedFile,
    handleAttachmentDate,
    handleDeleteFile,
    values,
    setValues,
    errors,
    setErrors,
    createMsg,
    show,
    setShow,
    setCreateMsg,
    country,
    currency,
    company,
    designation,
    type,
    setCountry,
    setCompany: handleCompanyChange,
    setCurrency,
    setDesignation,
    setType,
    errorShow,
    setErrorShow,
    ErrorDoneClick,
    SuccessDoneClick,
    docError,
    setDocError, loading, setLoading, handleStatusChange,
    HandleDragOver, HandleDrop,
    authPerson,
    setAuthPerson: handleAuthPersonChange,
    assignedEngineer,
    setAssignedEngineer: handleAssignedEngineerChange
  };
};

export default useForm;
